export default __webpack_public_path__ + "static/media/marketing@2x.26d255ad.png";